import {useState} from "react";
import {Form, FormSelect} from "react-bootstrap";
import styles from "./index.module.scss";

interface IChoose {
    disabled: boolean;
    step: number
    setStep: any
    data: any
    getNext?: any
    name: any
}

const Choose = ({disabled, step, setStep, data, getNext, name}: IChoose) => {
    const [isSelect, setIsSelect] = useState(true);
    const [selectValue, setSelectValue] = useState("");
    const [inputValue, setInputValue] = useState("");

    const add = isSelect ? styles.none : "";
    const select = !isSelect ? styles.none : "";

    const handleChange = () => {
        setIsSelect(!isSelect);
        setInputValue("");
        setSelectValue("");
    };

    const nextStep = () => {
        setStep(step + 1)
    }
    return (
        <div className={`${styles.choose} ${disabled ? styles.disabled : ""}`}>
            <FormSelect
                disabled={disabled}
                className={select}
                name={name}
                onChange={(event: any) => {
                    setSelectValue(event.target.value)
                    getNext(event.target.value)
                    nextStep()
                }}
                value={selectValue}
            >
                <option>Марка авто</option>
                {data.length &&
                    data.map((el: any) => (
                        <option value={el.id}>{el.name}</option>
                    ))}
            </FormSelect>
            <Form.Control
                disabled={disabled}
                className={add}
                onChange={(event) => setInputValue(event.target.value)}
                value={inputValue}
                placeholder="Добавьте нужную деталь"
            />
            <h5 className={add} onClick={handleChange}>
                -
            </h5>
            <h5 className={select} onClick={handleChange}>
                +
            </h5>
        </div>
    );
};

export default Choose;
